import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { BookOpen, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DevotionalsPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [devotionals, setDevotionals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (!authLoading && !user) navigate("/login"); }, [user, authLoading, navigate]);

  useEffect(() => {
    axios.get(`${API}/devotionals`).then(res => setDevotionals(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (authLoading || !user) return null;

  return (
    <div data-testid="devotionals-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Daily Reading</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Devotionals</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white min-h-[50vh]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-20"><Loader2 className="w-6 h-6 text-[#C8A97E] animate-spin mx-auto" /></div>
          ) : devotionals.length === 0 ? (
            <div className="text-center py-20">
              <BookOpen className="w-12 h-12 text-[#E5E2DC] mx-auto mb-4" />
              <h2 className="font-serif text-xl font-semibold text-[#1C2E4A] mb-2">Devotionals Coming Soon</h2>
              <p className="text-[#595959] max-w-md mx-auto mb-2">Our church leadership is preparing devotional content for you. Check back regularly for new readings rooted in God's Word.</p>
              <p className="text-sm text-[#595959]/60">New devotionals are posted weekly based on KJV scripture.</p>
            </div>
          ) : (
            <div className="space-y-8">
              {devotionals.map((d) => (
                <article key={d.id} data-testid={`devotional-${d.id}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-8">
                  <p className="text-xs uppercase tracking-[0.15em] text-[#C8A97E] font-semibold mb-2">{d.verse_ref}</p>
                  <h2 className="font-serif text-xl font-semibold text-[#1C2E4A] mb-3">{d.title}</h2>
                  {d.scripture_text && (
                    <blockquote className="font-serif italic text-sm text-[#1C2E4A]/80 border-l-2 border-[#C8A97E] pl-4 mb-4">
                      {d.scripture_text}
                    </blockquote>
                  )}
                  <p className="text-sm text-[#595959] leading-relaxed whitespace-pre-line mb-4">{d.message}</p>
                  {d.prayer && (
                    <div className="bg-white rounded-lg p-4 border border-[#E5E2DC]">
                      <p className="text-xs font-semibold text-[#1C2E4A] mb-1">Prayer</p>
                      <p className="text-sm text-[#595959] italic">{d.prayer}</p>
                    </div>
                  )}
                  <p className="text-xs text-[#595959]/50 mt-4">{new Date(d.created_at).toLocaleDateString()}</p>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
